import { normalizeText } from './textNormalizationHelpers';

const QUOTATION_STATUS_GROUPS = Object.freeze({
  atencao: [
    'estimativa entregue',
    'pendente de aprovacao',
    'pronto para retirada',
  ],
  andamento: [
    'aguardando estimativa',
    'aguardando equipamento',
    'equipamento recebido',
    'aguardando orcamento',
    'aprovado para manutencao',
    'aguardando inspecao e laudo',
    'aguardando faturamento',
  ],
  concluidos: [
    'recusado',
    'finalizado',
    'concluido',
    'estimativa recusada',
    'estimativa finalizada',
    'enviado',
  ],
});

function getStatusGroup(statusValue) {
  const normalizedStatus = normalizeText(statusValue);

  if (QUOTATION_STATUS_GROUPS.atencao.includes(normalizedStatus)) return 'atencao';
  if (QUOTATION_STATUS_GROUPS.concluidos.includes(normalizedStatus)) return 'concluidos';
  if (QUOTATION_STATUS_GROUPS.andamento.includes(normalizedStatus)) return 'andamento';

  return 'andamento';
}

function getQuotationStatusVariant(statusValue) {
  const normalizedStatus = normalizeText(statusValue);
  const statusGroup = getStatusGroup(normalizedStatus);

  if (statusGroup === 'atencao') return 'danger';
  if (statusGroup === 'concluidos') return 'success';

  if (
    normalizedStatus.includes('pendente') ||
    normalizedStatus.includes('entregue') ||
    normalizedStatus.includes('pronto para retirada')
  ) {
    return 'danger';
  }

  if (
    normalizedStatus.includes('recusado') ||
    normalizedStatus.includes('finalizado') ||
    normalizedStatus.includes('concluido')
  ) {
    return 'success';
  }

  return 'info';
}

function createEmptyQuotationGroups() {
  return {
    atencao: [],
    andamento: [],
    concluidos: [],
  };
}

function groupQuotesByStatus(quotes = []) {
  const grouped = createEmptyQuotationGroups();

  if (!Array.isArray(quotes)) return grouped;

  quotes.forEach((quote) => {
    const group = getStatusGroup(quote?.status);
    grouped[group].push(quote);
  });

  return grouped;
}

export {
  QUOTATION_STATUS_GROUPS,
  createEmptyQuotationGroups,
  getStatusGroup,
  getQuotationStatusVariant,
  groupQuotesByStatus,
};

